var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1235 0.19762C12.9849 0.201748 12.8534 0.259657 12.7568 0.359078L4.60057 8.51533L1.24432 5.15908C1.19517 5.10789 1.13631 5.06703 1.07117 5.03887C1.00604 5.01072 0.93594 4.99585 0.864985 4.99513C0.79403 4.99441 0.723644 5.00785 0.65795 5.03467C0.592255 5.06149 0.532573 5.10115 0.482397 5.15133C0.432222 5.2015 0.392562 5.26118 0.365742 5.32688C0.338921 5.39257 0.325478 5.46296 0.326199 5.53391C0.326921 5.60487 0.341794 5.67497 0.369946 5.7401C0.398098 5.80524 0.438963 5.8641 0.490149 5.91324L4.22348 9.64658C4.32351 9.74656 4.45914 9.80272 4.60057 9.80272C4.74199 9.80272 4.87763 9.74656 4.97765 9.64658L13.511 1.11324C13.5881 1.03833 13.6407 0.941883 13.662 0.836539C13.6833 0.731195 13.6723 0.62187 13.6304 0.522891C13.5885 0.423912 13.5177 0.339896 13.4273 0.281854C13.3368 0.223812 13.2309 0.194451 13.1235 0.19762Z",
    fill: "#1D2E99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.99229be576e5533818b83d54007909dc.svg";
export { ForwardRef as ReactComponent };